import Hero from "../components/sections/Hero";
import About from "../components/sections/About";
import Services from "../components/sections/Services";
import Benefits from "../components/sections/Benefits";
import Portfolio from "../components/sections/Portfolio";
import CTABanner from "../components/sections/CTABanner";
import Team from "../components/sections/Team";
import Testimonials from "../components/sections/Testimonials";
import Blog from "../components/sections/Blog";
import Contact from "../components/sections/Contact";

export default function HomePage() {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Benefits />
      <Portfolio />
      <CTABanner />
      <Team />
      <Testimonials />
      <Blog />
      <Contact />
    </>
  );
}
